import { render, staticRenderFns } from "./OSRWaitingAnswer.vue?vue&type=template&id=7acbb8f6"
import script from "./OSRWaitingAnswer.vue?vue&type=script&lang=js"
export * from "./OSRWaitingAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports